<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>报告编辑</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/checkreport')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="110px"
        ref="formData"
      >
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="formData.templateName"></el-input>
        </el-form-item>

        <el-form-item label="报表文件名称" prop="templateReport">
          <el-input v-model="formData.templateReport"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="deviceType">
          <el-select v-model="formData.deviceType">
            <el-option
              v-for="ele in deviceTypeList"
              :key="ele.value"
              :label="ele.label"
              :value="ele.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型" prop="templateType">
          <el-select v-model="formData.templateType">
            <el-option
              v-for="ele in templateList"
              :key="ele.value"
              :label="ele.label"
              :value="ele.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测依据" prop="testbasis">
          <el-input v-model="formData.testbasis" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="最大不符合项数" prop="maxNotpass">
          <el-input v-model="formData.maxNotpass" type="number"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="formData.status"></el-input> -->
          <el-radio-group v-model="formData.status" size="small">
            <el-radio :label="1" border>启用</el-radio>
            <el-radio :label="2" border>禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板事项信息" prop="itempageList">
          <el-button type="primary" @click="itemInfo" size="small"
            >添加事项信息</el-button
          >
          <!-- 表格 -->
          <TzTable
            :height="320"
            :tableData="formData.itempageList"
            :columns="itemColumnsEdit"
          />
        </el-form-item>
        <el-form-item label="设备仪器信息" prop="toolspageList">
          <el-button type="primary" @click="toolsInfo" size="small"
            >添加仪器信息</el-button
          >

          <!-- 表格 -->
          <TzTable
            :height="320"
            :tableData="formData.toolspageList"
            :columns="toolsColumnsEdit"
          />
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>保存</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>

      <!-- card content -->
    </el-card>
    <!-- card -->
    <!-- 仪器添加弹框 -->
    <EditTooltable
      :page="toolsnum"
      :size="toolssize"
      :total="toolstotal"
      :state="toolsEdit"
      @close="toolsEdit = false"
      :tableData="toolsList"
      :columns="toolsColumns"
      @handleSizeChange="toolsSizeChange"
      @handleCurrentChange="toolsCurrentChange"
      @valueSearch="toolsSearch"
      @handleSelectionChange="toolsSelectionChange"
      @confirm="toolsCreate"
    />
    <!-- 事项添加弹框 -->
    <EditItemtable
      :page="itemnum"
      :size="itemsize"
      :total="itemtotal"
      :state="itemEdit"
      @close="itemEdit = false"
      :tableData="itemList"
      :columns="itemColumns"
      @handleSizeChange="itemSizeChange"
      @handleCurrentChange="itemCurrentChange"
      @valueSearch="itemSearch"
      @handleSelectionChange="itemSelectionChange"
      @confirm="itemCreate"
    />
  </div>
</template>

<script>
import {
  updateReport,
  queryToolList,
  queryItemList,
  getList
} from '@/api/checkreport'
import { queryEquipment } from '@/api/dictionary'
import TzTable from '@/components/tz-table/Index.vue'
import EditTooltable from './components/EditTooltable'
import EditItemtable from './components/EditItemtable'

export default {
  components: {
    TzTable,
    EditTooltable,
    EditItemtable
  },
  data() {
    return {
      tempId: '',
      // 事项信息
      itemnum: 1, //当前页
      itemsize: 5,
      itemtotal: 100,
      itemSelect: [],
      itemList: [],
      itemEdit: false,

      // 仪器信息
      toolsnum: 1, //当前页
      toolssize: 5,
      toolstotal: 100,
      toolsSelect: [],
      toolsList: [],
      toolsEdit: false,
      templateList: [],
      deviceTypeList: [],
      formData: {
        templateName: '',
        templateReport: '',
        deviceType: '',
        templateType: '',
        testbasis: '',
        maxNotpass: '',
        status: 1,
        toolspageList: [],
        itempageList: []
      },

      rules: {},
      // 模板事项信息
      itemColumns: [
        {
          field: 'sort',
          title: '序号'
        },
        {
          field: 'itemType',
          title: '事项类型'
        },
        {
          field: 'itemName',
          title: '事项名称'
        },
        {
          field: 'resultValue',
          title: '检测结果默认值'
        },
        {
          field: 'qualifiedType',
          title: '检测合格类型'
        }
      ],
      itemColumnsEdit: [
        {
          field: 'sort',
          title: '序号'
        },
        {
          field: 'itemType',
          title: '事项类型'
        },
        {
          field: 'itemName',
          title: '事项名称'
        },
        {
          field: 'resultValue',
          title: '检测结果默认值'
        },
        {
          field: 'qualifiedType',
          title: '检测合格类型'
        },
        {
          title: '操作',
          width: '100',
          type: 'btn',
          payload: [
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteItemFn(row)
              }
            }
          ]
        }
      ],
      // 设备仪器信息
      toolsColumns: [
        {
          field: 'toolname',
          title: '仪器名称'
        },
        {
          field: 'px',
          title: '排序'
        }
      ],
      toolsColumnsEdit: [
        {
          field: 'toolname',
          title: '仪器名称'
        },
        {
          field: 'px',
          title: '排序'
        },
        {
          title: '操作',
          width: '100',
          type: 'btn',
          payload: [
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteToolsFn(row)
              }
            }
          ]
        }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        },
        {
          content: '重置',
          width: '185px',
          type: ''
        }
      ]
    }
  },
  created() {
    let types = ['equipment_type', 'template_type']
    queryEquipment(types).then((res) => {
      this.deviceTypeList = res.data.equipment_type
      this.templateList = res.data.template_type
    })
    this.setup()
  },
  methods: {
    // 列表数据
    setup() {
      console.log(this.$route.query)
      let datas = this.$route.query
      this.tempId = datas.id
      let params = {
        id: datas.id
      }
      getList(params).then((res) => {
        if (res.code == 200) {
          let rowData = res.data.template
          this.formData.templateName = rowData.templateName
          this.formData.templateReport = rowData.templateReport
          this.formData.templateType = rowData.templateType
          this.formData.testbasis = rowData.testbasis
          this.formData.deviceType = rowData.deviceType
          this.formData.maxNotpass = rowData.maxNotpass
          this.formData.status = rowData.status
          this.formData.toolspageList = res.data.tools ? res.data.tools : []
          this.formData.itempageList = res.data.items ? res.data.items : []
        }
      })
    },
    // 分页
    toolsSizeChange(val) {
      this.toolssize = val
      this.toolsSearch()
    },
    toolsCurrentChange(val) {
      this.toolsnum = val
      this.toolsSearch()
    },
    itemSizeChange(val) {
      this.itemsize = val
      this.itemSearch()
    },
    itemCurrentChange(val) {
      this.itemnum = val
      this.itemSearch()
    },
    // 事项信息
    // 事项信息添加
    itemInfo() {
      this.itemnum = 1
      this.itemSearch()
      this.itemEdit = true
    },
    // 事项查询
    itemSearch(e) {
      console.log(e)
      if (e) this.itemnum = 1
      let params = {
        itemname: e,
        pageSize: this.itemsize,
        pageNum: this.itemnum
        // templateId: this.size,
      }
      console.log(e)
      queryItemList(params).then((res) => {
        if (res.code == 200) {
          let itemArr = res.data.records
          this.itemtotal = res.data.total
          this.itemList = itemArr.map((item) => {
            return {
              id: item.id,
              itemName: item.itemName,
              sort: item.sort,
              itemType: item.dictName_itemType,
              resultValue: item.dictName_resultValue
            }
          })
        }
      })
    },
    itemSelectionChange(val) {
      console.log(val)
      this.itemSelect = val
    },
    itemCreate(type) {
      if (type === '确定') {
        // if (this.submited) return
        let itemarr = []
        this.itemSelect.forEach((item) => {
          if (!this.formData.itempageList.find((el) => el.id === item.id)) {
            itemarr.push(item)
          } else {
            this.$message({
              type: 'error',
              message: '事项添加重复，已过滤'
            })
          }
        })
        this.formData.itempageList = this.formData.itempageList.concat(itemarr)
        this.$loading({
          text: '事项添加中'
        })
        // this.toolspageList = this.toolspageList.concat(this.toolsSelect)
        this.itemEdit = false
        this.$loading().close()
        this.itemSelect = []
        this.itemList = []

        // this.submited = true
        // this.$message({
        //   message: '添加成功',
        //   type: 'success'
        // })

        this.$loading().close()
      } else if (type == '取消') {
        this.itemEdit = false
        this.itemSelect = []
        this.itemList = []
      }
    },
    // 事项信息删除
    deleteItemFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(row)
          this.formData.itempageList = this.formData.itempageList.filter(
            (item) => item.id != row.id
          )
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 仪器信息
    // 仪器查询
    toolsSearch(e) {
      console.log(e)
      if (e) this.toolsnum = 1
      let params = {
        toolname: e,
        pageSize: this.toolssize,
        pageNum: this.toolsnum
        // templateId: this.size,
      }
      console.log(e)
      queryToolList(params).then((res) => {
        if (res.code == 200) {
          let toolArr = res.data.records
          this.toolstotal = res.data.total
          this.toolsList = toolArr.map((item) => {
            return {
              id: item.id,
              toolname: item.toolname,
              px: item.px
            }
          })
        }
      })
    },
    toolsSelectionChange(val) {
      console.log(val)
      this.toolsSelect = val
    },
    // 仪器信息添加
    toolsInfo() {
      this.toolsnum = 1
      this.toolsSearch()
      this.toolsEdit = true
    },

    // 仪器信息添加
    toolsCreate(type) {
      if (type === '确定') {
        // if (this.submited) return
        let toolsarr = []
        this.toolsSelect.forEach((item) => {
          if (!this.formData.toolspageList.find((el) => el.id === item.id)) {
            console.log(item)
            toolsarr.push(item)
          } else {
            this.$message({
              type: 'error',
              message: '仪器添加重复，已过滤'
            })
          }
        })
        this.formData.toolspageList =
          this.formData.toolspageList.concat(toolsarr)
        this.$loading({
          text: '仪器添加中'
        })
        // this.toolspageList = this.toolspageList.concat(this.toolsSelect)
        this.toolsEdit = false
        this.$loading().close()
        this.toolsSelect = []
        this.toolsList = []

        // this.submited = true
        // this.$message({
        //   message: '添加成功',
        //   type: 'success'
        // })

        this.$loading().close()
      } else if (type == '取消') {
        this.toolsEdit = false
        this.toolsSelect = []
        this.toolsList = []
      }
    },
    // 仪器信息删除
    deleteToolsFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(row)
          this.formData.toolspageList = this.formData.toolspageList.filter(
            (item) => item.id != row.id
          )
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 重置报告
    clearFn() {
      this.$refs.formData.resetFields()
    },

    // 保存
    submitFn() {
      console.log('报告保存')

      if (this.submited) return
      this.$loading({
        text: '报告更新中'
      })
      let devices = this.deviceTypeList.find(
        (el) => el.label === this.formData.deviceType
      )
      if (devices) this.formData.deviceType = devices.value
      let templates = this.templateList.find(
        (el) => el.label === this.formData.templateType
      )
      if (templates) this.formData.templateType = templates.value
      // let repinfo = JSON.parse(JSON.stringify(this.formData))
      let itemsInfo = this.formData.itempageList.map((el) => {
        return el.id
      })
      let toolsInfo = this.formData.toolspageList.map((el) => {
        return el.id
      })
      let addparams = {
        id: this.tempId,
        templateName: this.formData.templateName,
        templateReport: this.formData.templateReport,
        deviceType: this.formData.deviceType,
        testbasis: this.formData.testbasis,
        status: this.formData.status,
        maxNotpass: this.formData.maxNotpass,
        intoSu: 0,
        templateType: this.formData.templateType,
        items: itemsInfo,
        tools: toolsInfo
      }
      console.log(addparams)
      updateReport(addparams).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.submited = true
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      this.$loading().close()
    }
  }
}
</script>

<style></style>
